export default {"src":"/_next/static/media/waves.e9237f6c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};